import apiClient from './apiClient';

export interface RedeemResult {
  patient: any;
  permissions: any;
  token_type: string;
  expires_at: string;
}

class AccessTokensService {
  async redeem(token: string, clinicId?: string): Promise<RedeemResult> {
    const response = await apiClient.post(`/access-tokens/${encodeURIComponent(token)}/redeem`, { clinic_id: clinicId });
    if (!response.data?.success) {
      throw new Error(response.data?.message || 'Token invalid');
    }
    return response.data.data as RedeemResult;
  }
}

export const accessTokensService = new AccessTokensService();


